import React from "react";
import i18n from "../../i18n";

export class DownloadApp extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="section-download py-5 bg-light" id="our_app">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Section */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="fw-bold mb-4  text-center">
                  {i18n.t("download_our_app")}
              </h2>
              <div className="row pt-4">
                {/* iOS Button */}
                <div className="col-6 text-center mb-3 ">
                  <a
                    href="https://apps.apple.com/ph/app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Auction App for iOS"
                      src="/assets/images/home/appstore.svg"
                      className="img-fluid w-70"

                    />
                  </a>
                </div>
                {/* Android Button */}
                <div className="col-6 text-center mb-3">
                  <a
                    href="https://play.google.com/store/apps/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Auction App for Android"
                      src="/assets/images/home/googleplay.webp"
                      className="img-fluid w-70"
                    />
                  </a>
                </div>
              </div>
            </div>

            {/* Right Section - Mobile Mockup */}
            <div className="col-lg-6 text-center text-lg-end">
              <img
                src="/assets/images/home/app-mockup.png"
                alt="Maxhome App Mockup"
                title="Acution Website In Oman"
                style={{ width: "800px", maxWidth: "100%" }}
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
